import {Breadcrumbs} from '../breadcrumbs/breadcrumbs';
import i18n from '../../utilities/i18n';
import React from 'react';
import './ikkebetalt.scss';
import {ErrorBox} from '../errorbox/errorbox';
import {env_vars} from '../../utilities/load-env';
import {useParams} from 'react-router-dom';


const IkkeBetalt = () => {
  const {lang} = useParams();

  return (
    <div className='container errorBoxMargin'>
      <section className='ikkeBetaltTitler'>
        <article className='pagetitle'>
          <Breadcrumbs crumbKey="lisensjeger" title={i18n.t('felles:lisensjeger')}/>
          <h1>{i18n.t('titel:hovedTitel')}</h1>
          <h2>{i18n.t('titel:subTitel')}</h2>
        </article>
        <ErrorBox>
          <h3>{i18n.t('betalt:ikkeBetaltMain')}</h3>
          <p>{i18n.t('betalt:ikkeBetaltSub')}</p>
          {lang === 'nb' || lang === 'nn' ?
            <a href={env_vars.BETALINGS_URL}>{i18n.t('betalt:gaTilBetaling')}</a>
              :
            <a href={env_vars.BETALINGS_URL_UTENLANDSK}>{i18n.t('betalt:gaTilBetaling')}</a>}
        </ErrorBox>
      </section>
    </div>
  );
};
export default IkkeBetalt;


